module.exports = require('./helpers/bundle-url').getBundleURL('ldSkg') + "logo.c51670a8.svg";